import React from 'react';
import { FacebookFilled, YoutubeFilled } from '@ant-design/icons';
import classnames from 'classnames';
import { renderFestivalClassName } from '@utils/.';
import GlobalFooter, { FooterProps } from '@components/GlobalFooter';

import style from './index.module.less';
import { FooterColumn } from '@components/GlobalFooter/Column';

const supportColumn: FooterColumn = {
  title: 'Hỗ trợ khách hàng',
  icon: null,
  items: [
    {
      title: (
        <span>
          Hotline: <strong>1900 6711</strong>
        </span>
      ),
      url: 'tel:19006711',
    },
    {
      title: (
        <span>
          Email: <strong>hotro@ampo.vn</strong>
        </span>
      ),
      url: 'mailto:hotro@ampo.vn',
    },
    {
      title: 'Chính sách giao hàng',
      url: '/delivery-policy',
    },
    {
      title: 'Chính sách bảo hành & đổi trả',
      url: '/warranty-policy',
    },
    {
      title: 'Hình thức thanh toán',
      url: '/payment-method',
    },
    {
      title: 'Hướng dẫn mua hàng',
      url: '/guide',
    },
    {
      title: 'Trạm bảo hành',
      url: '/warranty-station',
    },
  ],
};

const introColumn: FooterColumn = {
  title: 'Về Ampo',
  items: [
    {
      title: 'Giới thiệu Ampo',
      url: '/about',
    },
    {
      title: 'Chính sách bảo mật thông tin',
      url: '/privacy-policy',
    },
  ],
};

const connectColumn: FooterColumn = {
  title: 'Kết nối với chúng tôi',
  items: [
    {
      icon: <FacebookFilled />,
      title: 'Facebook',
      url: 'https://www.facebook.com/nanoco.com.vn',
    },
    {
      icon: <YoutubeFilled />,
      title: 'Youtube',
      url: 'https://www.youtube.com/@nanocovietnam',
    },
    {
      title: 'Nanoco',
      url: 'https://www.nanoco.com.vn',
      icon: <span>N</span>,
    },
  ],
};

const columns: FooterColumn[] = [supportColumn, introColumn, connectColumn];

const bottom: FooterProps['bottom'] = {
  title: 'Công ty CP Thiết Bị Điện Phước Thạnh',
  items: [
    {
      content:
        'Địa chỉ: Lô D05, Khu công nghiệp Đức Hoà 1 - Hạnh Phúc, Ấp 5, Xã Đức Hoà Đông, Huyện Đức Hoà, Tỉnh Long An, Việt Nam',
    },
    {
      content: 'Mã số thuế: 1100793386',
    },
  ],
};

const Footer = ({ festival }: { festival?: string }) => (
  <GlobalFooter
    className={classnames(
      style.footer,
      renderFestivalClassName(festival || '', { chrismas: style.chrismas, tet: style.tet }),
    )}
    festival={festival}
    columns={columns}
    contentItems={[]}
    maxColumnsPerRow={0}
    bottom={bottom}
  />
);

export default Footer;
